import type { EntityStatus } from '@ms/yammer-data-support';
import { getStatus } from '@ms/yammer-data-support';

import type { YammerState } from '../../state/types';

type GetUserAchievementsSettingsStatus = (state: YammerState) => EntityStatus;
export const getUserAchievementsSettingsStatus: GetUserAchievementsSettingsStatus = (state) =>
  getStatus(state.userAchievementsSettings);

export const getViewerCanEditUserAchievementsSettings = (state: YammerState) =>
  state.userAchievementsSettings.fulfilled?.viewerCanEditSettings || false;

export const getUserAchievementsSettings = (state: YammerState) => state.userAchievementsSettings.fulfilled;
